// extracted by mini-css-extract-plugin
module.exports = {"container":"LandingPage_container__1eW2e","background":"LandingPage_background__2qOMd","button":"LandingPage_button__2I7Tw","title":"LandingPage_title__2-Ama"};